import clsx from 'clsx';
import React, { ReactNode } from 'react';
import { Header, Icon } from 'semantic-ui-react';
import { SemanticSIZES } from 'semantic-ui-react/dist/commonjs/generic';
import { PosAnimatedImagesId } from '../../enums/PosAnimatedImageNames';
import { POSAnimatedImage } from '../POSAnimatedImage/POSAnimatedImage';
import POSIcon from '../POSIcon';
import './POSNotification.less';

export interface Props {
  type: 'success' | 'warning' | 'info' | 'error';
  title: string | React.ReactNode;
  content: string | React.ReactNode;
  link?: React.ReactNode;
  inverted?: boolean;
  image?: PosAnimatedImagesId | ReactNode;
  onClick?: () => void;
  imageSize?: SemanticSIZES;
  closeToast?: () => void;
}

export const POSNotification = ({
  content,
  title,
  link,
  inverted,
  closeToast,
  image,
  onClick,
  imageSize,
  type,
}: Props) => {
  const getImageNameByType = (): PosAnimatedImagesId => {
    const prefix =
      type === 'success' ? 'Positive' : type === 'error' ? 'Negative' : 'Idle';
    const suffix = inverted ? 'White' : 'Black';

    return (prefix + suffix) as PosAnimatedImagesId;
  };

  const renderImage = () => {
    if (!image) {
      return <POSAnimatedImage size="tiny" image={getImageNameByType()} />;
    }

    if (image && typeof image === 'string') {
      return (
        <POSAnimatedImage
          size={imageSize}
          image={image as PosAnimatedImagesId}
        />
      );
    }

    return image;
  };

  return (
    <div className={clsx('pos-notification', { inverted: inverted })}>
      <Icon link className="pos close" onClick={closeToast} />

      <div className="content">
        <div className="image">{renderImage()}</div>
        <div className="text">
          <Header as="h4">{title}</Header>
          {content}
        </div>
      </div>

      {link && (
        <div className="footer">
          <span className="link" onClick={onClick}>
            {link} <POSIcon icon="arrow-right" />
          </span>
        </div>
      )}
    </div>
  );
};
